export const TIMEZONE = 'Europe/Amsterdam';
//# sourceMappingURL=timezone.js.map